module.exports = __webpack_public_path__ + "static/img/declare_one.3a7ff12.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/declare_one.jpg
// module id = lCTc
// module chunks = 1